//Used for Vaccination table in the Appointment view and auditing AppointmentDelta 
export const RabiesVaccinationTableHeaderColumn = [
    "Title",
    "SerialNumber",
    "DateOfApplication",
    "ExpirationDate",
    "ImmunityPeriod",
    "IsFirstRabiesVaccine",
    "Description"
];

export const OtherVaccinationTableHeaderColumn = [
    "Title",
    "Lot",
    "PowderExpirationDate",
    "SolventExpirationDate",
];